import ShimmerScreen from "../../../Layouts/ShimmerScreen";
import "./CategoryTagComponent.scss";
import { useNavigate } from "react-router-dom";

const CategoryTagComponent = ({ name, isLoading, isMobile }) => {
  let navigate = useNavigate();
  return (
    <div
      className={`category-tags ${isLoading ? "" : "cursor-pointer"}`}
      onClick={() => {
        if (isLoading) {
        } else {
          if (isMobile) {
            let obj = { name: "click-on-tag", tagName: name };
            if (window.callbackHandler != undefined) {
              window.callbackHandler.postMessage(JSON.stringify(obj));
            } else if (window.webkit != undefined) {
              if (window.webkit.messageHandlers.callbackHandler != undefined) {
                window.webkit.messageHandlers.callbackHandler.postMessage(
                  JSON.stringify(obj)
                );
              }
            }
          } else {
            navigate(`/search?keyword=${name}`);
          }
        }
      }}
    >
      {isLoading ? (
        <ShimmerScreen case="rect" width={`${name + 6}rem`} height="1.4rem" />
      ) : (
        name
      )}
    </div>
  );
};

export default CategoryTagComponent;
